import { User, USER_STATUS_ENABLED } from '../types';

export const isUserInactive = (user?: Partial<User>): boolean => {
    if (!user?.status) {
        return false; // Don't assume a user is inactive if the status is not defined
    }
    return !(USER_STATUS_ENABLED as readonly string[]).includes(user.status.toLowerCase());
};
